import React from 'react';
import { array, func } from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import { formatFootage } from '../../utils/number-util';
import { formatUOMLabel } from '../../utils/format-utils';
import classes from './AreasTable.module.css';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f4f4f4',
        }
    }
}))(TableRow);

const AreasTable = ({
    areas,
    onSort,
    order,
    orderBy,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell
                        className={classes.headerCell}
                        sortDirection={sortDirection}
                        onClick={onSort('name')}
                    >
                        <Tooltip
                            title={
                                <span className={classes.tooltip}>
                                    Sort
                                </span>
                            }
                            placement="top-start"
                        >
                            <TableSortLabel
                                active={isSortedByName}
                                direction={order}
                            >
                                Name
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                    <TableCell className={classes.headerCell}>
                        Area
                    </TableCell>
                    <TableCell className={classes.headerCell}>
                        Unit Of Measure
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {areas.map(item =>
                    <StyledTableRow key={item.id}>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {item.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{item.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {formatFootage(item.squareFootage)}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{formatFootage(item.squareFootage)}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {formatUOMLabel(item.squareAreaUOM)}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{formatUOMLabel(item.squareAreaUOM)}</span>
                            </Tooltip>
                        </TableCell>
                    </StyledTableRow>
                )}
            </TableBody>
        </Table>
    );
};

AreasTable.defaultProps = {
    areas:  [],
    onSort: () => {}
};

AreasTable.propTypes = {
    areas:  array.isRequired,
    onSort: func
};

export default AreasTable;
